"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingEnum = void 0;
var RatingEnum;
(function (RatingEnum) {
    RatingEnum[RatingEnum["ONE_STAR"] = 0] = "ONE_STAR";
    RatingEnum[RatingEnum["TWO_STARS"] = 1] = "TWO_STARS";
    RatingEnum[RatingEnum["THREE_STARS"] = 2] = "THREE_STARS";
    RatingEnum[RatingEnum["FOUR_STARS"] = 3] = "FOUR_STARS";
    RatingEnum[RatingEnum["FIVE_STARS"] = 4] = "FIVE_STARS";
})(RatingEnum || (exports.RatingEnum = RatingEnum = {}));
